<template>
  <div>
    <div class="text-sm mb-1 opacity-50 label" v-if="label">
      {{ label }}
    </div>
    <textarea
      v-if="typeof this.onEnter === 'function'"
      v-model.trim="innerValue"
      :placeholder="placeholder"
      @keydown.enter.exact.prevent="handleEnter"
      @keydown.ctrl.enter="breakLine"
      @blur="onBlur"
      @focus="$emit('focus', $event)"
      :style="textStyle"
      rows="1"
      ref="node"
    />
    <textarea
      v-else
      v-model.trim="innerValue"
      :placeholder="placeholder"
      :style="textStyle"
      rows="1"
      ref="node"
      @blur="onBlur"
      @focus="$emit('focus', $event)"
    />
  </div>
</template>

<script>
import autosize from '@/utils/autosize'

export default {
  name: 'uiTextarea',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    onResize: {
      type: Function
    },
    onEnter: {
      type: Function
    },
    minRows: {
      type: Number,
      default: 1
    },
    label: {
      type: String
    },
    fontSize: {
      type: Number,
      default: 15
    },
    fontOpacity: {
      type: Number,
      default: 1
    },
    fontBold: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      innerValue: ''
    }
  },
  computed: {
    textStyle () {
      return {
        fontSize: this.fontSize + 'px',
        fontWeight: this.fontBold ? 'bold' : 'normal',
        color: `rgba(0, 0, 0, ${this.fontOpacity})`
      }
    }
  },
  mounted () {
    this.node = this.$el.querySelector('textarea')

    this.innerValue = this.value
    this.$nextTick(() => autosize(this.node))

    this.node.addEventListener('autosize:resized', () => {
      if (typeof this.onResize === 'function') this.onResize()
    })
  },
  methods: {
    handleEnter () {
      if (typeof this.onEnter === 'function') {
        this.onEnter()
      }
    },
    breakLine () {
      this.innerValue += '\n'
    },
    onBlur (e) {
      this.$emit('blur', e)
      let timeout = setTimeout(() => {
        autosize.update(this.node)
        clearTimeout(timeout)
      }, 0)
    }
  },
  watch: {
    value (newVal) {
      this.innerValue = newVal
      this.node = this.$el.querySelector('textarea')
      this.$nextTick(() => autosize.update(this.node))
    },
    innerValue (newVal) {
      if (!this.$refs['node']) return
      this.$emit('input', newVal)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

textarea {
  resize: none;
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  overflow: hidden;
  box-sizing: border-box;
  background: @grey;
  padding: 15px 20px;
  display: block;
  border-radius: 10px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

  &::placeholder {
    color: fade(#000, 30%);
    transition: color 0.2s;
  }

  &:focus {
    &::placeholder {
      color: transparent;
    }
  }
}
</style>
